const checkDiscountProductInCart = async function(id,discountcode){
  const response = await fetch("/cart.js");
  const data = await response.json();
  const matched = data.items.filter( item => item.id == id && (item.properties != null && item.properties._isFree == 1));
  return matched.length > 0 ? matched[0].key : false;
};
const removeProductIfDiscountNotExisit = async function(id,discountcode){
  const response = await fetch("/cart.js");
  const data = await response.json();
  const matched = data.items.filter( item => item.id == id && (item.properties != null && item.properties._isFree == 1));
  const discountMatched = data.items.filter( (item) => {
    return item.discounts.filter(discount => discount.title == discountcode).length > 0;
  });
  /* NK 2026-10-28: a 100%-off-the-gift code (MYSTERY) stays applied on the gift alone once the knife is gone,
     so the gift only stays while something that is not a free gift is in the cart */
  const paidItems = data.items.filter( item => !(item.properties != null && (item.properties._isFree == 1 || item.properties.isFree == 1 || item.properties._nk_gift)));
  
  if(discountMatched.length > 0 && paidItems.length > 0){
    if(matched.length <= 0){
       const addRemobed = await addRemoveDiscountProduct(id,1);
        document.dispatchEvent(new CustomEvent('cart:build'));
     
       
    }
  }else{
     if(matched.length > 0){
        const addRemobed = await addRemoveDiscountProduct(matched[0].key,0);
        //document.dispatchEvent(new CustomEvent('cart:build'));
     }
  }
}
const initCustomDiscountEvent = function() {
  if(document.querySelectorAll(".discount-apply-btn").length > 0){

   const productId = document.querySelector(".discount-apply-btn").dataset.id;
   const code = document.querySelector(".discount-apply-btn").dataset.code;
   removeProductIfDiscountNotExisit(productId,code);
   document.querySelector(".discount-input").addEventListener("keydown", function(event) {
    if (event.key === "Enter") {
      console.log("NK enter clicked");
      event.stopPropagation();
      event.preventDefault();
      event.stopImmediatePropagation();
        // Do Something, may be an 'Undo' operation
          document.querySelector('.discount-apply-btn').click();
      }
  });
    document.querySelector(".discount-apply-btn").addEventListener("click", async function(e){
      const button = e.currentTarget;
      const productId = e.currentTarget.dataset.id;
      const code = e.currentTarget.dataset.code;
      const enteredCode = document.querySelector(".discount-input").value;
      button.classList.add('btn--loading');
      let isProductedAdded = false;
      const discountProductOnCart = await checkDiscountProductInCart(productId,code);

       if (enteredCode.toLowerCase() == code.toLowerCase() && (productId != null && productId != '')) {
        if (discountProductOnCart == false) {
            isProductedAdded = await addRemoveDiscountProduct(productId, 1);
            //isProductedAdded = await checkDiscountProductInCart(productId,code);
        }
      }
      setTimeout( async function(){
        const discountResponse = await applyCustomDiscount(enteredCode,productId);

        setTimeout( async function(){
          const cartResponse = await fetch("/cart.js");
          const data = await cartResponse.json();
          const discountMatched = data.items.filter( (item) => {
            return item.discounts.filter( discount => discount.title == enteredCode ).length > 0;
          });
          
          if(discountMatched.length <= 0 && isProductedAdded !== false){
             addRemoveDiscountProduct(isProductedAdded, 0);
          }
          
          if(data.cart_level_discount_applications.length <= 0 && discountMatched.length <= 0){
             document.querySelector(".custom-error-div").classList.remove("hide");
          }
          setTimeout( () => {
               button.classList.remove('btn--loading');
              document.dispatchEvent(new CustomEvent('cart:build'));
            },1000);
        },300);
        
      },500);
      
      
    });
     document.querySelectorAll(".custom-d-badge .close-wrapper").forEach( (el) => {
         el.addEventListener("click", async function(e){
            const deletedId = document.querySelector(".discount-apply-btn").dataset.id;
             const re = await removeCustomDiscount("ddd");
             const discountProductOnCart = await checkDiscountProductInCart(deletedId,"");
           if(discountProductOnCart != false){
              addRemoveDiscountProduct(discountProductOnCart, 0);
           }
             
            setTimeout(() => {
              
               document.dispatchEvent(new CustomEvent('cart:build'));
            },500);
         });
     });
  }
};

const addRemoveDiscountProduct = async function(id,qty){
  if(qty == 1){
    let formData = {
     'items': [{
      'id': id,
      'quantity': qty,
       "properties":{
         "_isFree":1
       }
      }]
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    return data.items[0].key;
    //document.dispatchEvent(new CustomEvent('cart:build'));
  }else{
     theme.cart.changeItem(id, qty)
    .then(function(cart) {
       document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }
  return true;
}
const applyCustomDiscount = async function(discountCode ,id){
  if(discountCode === 'FREEBOOK'){
    const freecookBook = await addFreebook();
  }
  const checkoutUrl = `https://northernknife.co.uk/checkout?discount=${discountCode}`;
  const response = await fetch(checkoutUrl);
  return true;
}
const removeCustomDiscount = async function(discountCode){
  const checkoutUrl = `https://northernknife.co.uk/checkout?discount=${discountCode}`;
  const response = await fetch(checkoutUrl);
  return true;
}
const addFreebook = async function(){
   let isExecuteFunction = true;

  if(theme.settings.abTest014 == 'test'){
    if(document.body.classList.contains("hw-abt-14-1")){
      isExecuteFunction = true;
    }else if(document.body.classList.contains("hw-abt-14-2")){
       isExecuteFunction = true;
    }else{
       isExecuteFunction = false;
    }
  }else if(theme.settings.abTest014 == 'v0'){
     isExecuteFunction = false;
  }
  if(isExecuteFunction == false){
    return false;
  }
 const id = 48322574188879;
  const v1 = 44579573498163;
  const v2 = 44579573563699;
  const v3 = 44579573596467;
  
  const response = await fetch("/cart.js");
  const data = await response.json();
 
  if(data.item_count > 0){
    let itemCount = data.item_count;
    const matched = data.items.filter( item => item.id == id);  
    let isContinue = false;
    if(document.body.classList.contains("hw-abt-14-1") || document.querySelectorAll(".cook-book-wrapper.v1").length > 0 || theme.settings.abTest014 == "v1"){
      const lokiItem = data.items.filter( item => (item.id == v2 || item.id == v3 || item.id == v1));
      if(lokiItem.length > 0){
        document.querySelector(".custom-discount-text-wrapper").classList.remove("hide");
        isContinue = true;
      }else{
         isContinue = false;
      }
    }else if(document.body.classList.contains("hw-abt-14-2") || document.querySelectorAll(".cook-book-wrapper.v2").length > 0 || theme.settings.abTest014 == "v2"){
      const lokiItem = data.items.filter( item => (item.id == v2 || item.id == v3));
      if(lokiItem.length > 0){
        isContinue = true;
      }else{
        isContinue = false;
      }
    }
    console.log(isContinue,"isContinue");
    if(isContinue == false){
        return false;
    }
    if(matched.length <= 0){
      let formData = {
       'items': [{
        'id': id,
        'quantity': 1
        }]
      };
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      const addedData = await addResponse.json();
    }
  }
}
const checkFreeproductOncart = async function(){
  let isExecuteFunction = true;

  if(theme.settings.abTest014 == 'test'){
    if(document.body.classList.contains("hw-abt-14-1")){
      isExecuteFunction = true;
    }else if(document.body.classList.contains("hw-abt-14-2")){
       isExecuteFunction = true;
    }else{
       isExecuteFunction = false;
    }
  }else if(theme.settings.abTest014 == 'v0'){
     isExecuteFunction = false;
  }
  if(isExecuteFunction == false){
    return false;
  }
  const id = 48322574188879;
  const v1 = 44579573498163;
  const v2 = 44579573563699;
  const v3 = 44579573596467;
  
  const discountCode = 'FREEBOOK';
  
  const response = await fetch("/cart.js");
  const data = await response.json();

  if(data.item_count > 0){
    const discountMatched = data.items.filter( (item) => {
      return item.discounts.filter( discount => discount.title == discountCode ).length > 0;
    });
    
    let itemCount = data.item_count;
    const matched = data.items.filter( item => item.id == id);
    
    if(document.body.classList.contains("hw-abt-14-1") || document.querySelectorAll(".cook-book-wrapper.v1").length > 0 || theme.settings.abTest014 == "v1"){
      const lokiItem2 = data.items.filter( item => (item.id == v2 || item.id == v3 || item.id == v1));
       if(lokiItem2.length > 0){
         if(document.querySelector(".custom-discount-text-wrapper")){
            document.querySelector(".custom-discount-text-wrapper").classList.remove("hide");
           document.querySelector(".custom-discount-text-wrapper").style.display="block";
         }
       
       }
    }else if(document.body.classList.contains("hw-abt-14-2") || document.querySelectorAll(".cook-book-wrapper.v2").length > 0 || theme.settings.abTest014 == "v2"){
      const lokiItem2 = data.items.filter( item => (item.id == v2 || item.id == v3));
      if(lokiItem2.length > 0){
        if(document.querySelector(".custom-discount-text-wrapper")){
          document.querySelector(".custom-discount-text-wrapper").classList.remove("hide");
          document.querySelector(".custom-discount-text-wrapper").style.display="block";
        }
      }
    }
    
    if(discountMatched.length <= 0){
      if(matched.length > 0){
       theme.cart.changeItem(matched[0].key, 0).then(function(cart) {
         document.dispatchEvent(new CustomEvent('cart:build'));
       });
      }
      return;
    }
    
    let isContinue = false;
    if(document.body.classList.contains("hw-abt-14-1") || document.querySelectorAll(".cook-book-wrapper.v1").length > 0 || theme.settings.abTest014 == "v1"){
      const lokiItem = data.items.filter( item => (item.id == v2 || item.id == v3 || item.id == v1));
      if(lokiItem.length > 0){
        if(document.querySelector(".custom-discount-text-wrapper")){
          document.querySelector(".custom-discount-text-wrapper").classList.remove("hide");
          document.querySelector(".custom-discount-text-wrapper").style.display="block";
        }
        isContinue = true;
      }else{
        if(document.querySelector(".custom-discount-text-wrapper")){
        document.querySelector(".custom-discount-text-wrapper").classList.add("hide");
        }
        if(matched.length > 0){
         theme.cart.changeItem(matched[0].key, 0).then(function(cart) {
           document.dispatchEvent(new CustomEvent('cart:build'));
         });
          return;
        }
      }
    }else if(document.body.classList.contains("hw-abt-14-2") || document.querySelectorAll(".cook-book-wrapper.v2").length > 0 || theme.settings.abTest014 == "v2"){
      const lokiItem = data.items.filter( item => (item.id == v2 || item.id == v3));
      if(lokiItem.length > 0){
        if(document.querySelector(".custom-discount-text-wrapper")){
        document.querySelector(".custom-discount-text-wrapper").classList.remove("hide");
        document.querySelector(".custom-discount-text-wrapper").style.display="block";
        }
        isContinue = true;
      }else{
        isContinue = false;
        if(document.querySelector(".custom-discount-text-wrapper")){
        document.querySelector(".custom-discount-text-wrapper").classList.add("hide");
        }
        if(matched.length > 0){
         theme.cart.changeItem(matched[0].key, 0).then(function(cart) {
           document.dispatchEvent(new CustomEvent('cart:build'));
         });
          return;
        }
      }
    }
    
    /*let isContinue = true;
     if(document.body.classList.contains("neb-ab014-2") || document.querySelectorAll(".custom-main-implement-v2").length > 0){
       isContinue = false;
        testV2 = data.items.filter( item => (item.id == v2 || item.id == v3));
       console.log(testV2,"testV2");
       if(testV2.length > 0){
         isContinue = true;
       }else{
          if(matched.length > 0){
         theme.cart.changeItem(matched[0].key, 0)
            .then(function(cart) {
               document.dispatchEvent(new CustomEvent('cart:build'));
            });
          }
       }
     }*/
   
    /*if(document.body.classList.contains("neb-ab014-1") || document.querySelectorAll(".cook-book-wrapper.implement-v1").length > 0 || theme.settings.abTest014 == "implement-v1"){
       isContinue = true;
    }else{
      const testV2 = data.items.filter( item => (item.id == v2 || item.id == v3));
       if(testV2.length > 0){
         isContinue = true;
         document.querySelector(".custom-discount-text-wrapper").classList.remove("hide");
       }else{
         document.querySelector(".custom-discount-text-wrapper").classList.add("hide");
          if(matched.length > 0){
         theme.cart.changeItem(matched[0].key, 0)
            .then(function(cart) {
              removeCustomDiscount("123");
               document.dispatchEvent(new CustomEvent('cart:build'));
            });
          }
       }
    }*/
    if(isContinue == false){
        return false;
    }
    if(matched.length <= 0){
      let formData = {
       'items': [{
        'id': id,
        'quantity': 1
        }]
      };
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      const addedData = await addResponse.json();
       document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: null,
            addToCartBtn: null
          }
        }));
    }else{
      if(matched.length > 0){
        itemCount = itemCount - matched[0].quantity;
        if(itemCount == 0){
          theme.cart.changeItem(matched[0].key, 0)
            .then(function(cart) {
              removeCustomDiscount("123");
               document.dispatchEvent(new CustomEvent('cart:build'));
            });
        }
      }
    } 
  }
   
}
const updateAB027Content = () => {
  if(document.querySelector("body.hw-abt-27-2 .what-include-tab-main button")){
    document.querySelector("body.hw-abt-27-2 .what-include-tab-main button").click();
  }
}
let productReveiewSiper;
let egswiperTiktok;
let upsell_slider;
const initializeBodyObservation = () => {
  const targetNode = document.body;
  const config = { attributes: true };
  const flkity = Flickity.data(document.querySelector(".product-slideshow"));
  //const swiper = document.querySelector(".review-trending-swiper .swiper-container").swiper;
  const callbackforBody = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
       if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if(targetNode.classList.contains("hw-abt-9-1")){
          flkity.cells[1].element.style.display="block";
          flkity.cells[2].element.style.display="none";
          flkity.reloadCells();
        }else if(targetNode.classList.contains("hw-abt-9-2")){
          flkity.cells[1].element.style.display="none";
          flkity.cells[2].element.style.display="block";
          flkity.reloadCells();
        }else if(targetNode.classList.contains("hw-abt-9-3")){
          flkity.cells[1].element.style.display="block";
          flkity.cells[2].element.style.display="block";
          flkity.reloadCells();
        }
        if(targetNode.classList.contains("hw-abt-8-1")){
           productReveiewSiper = document.querySelector(".review-trending-swiper .swiper-container").swiper;
             productReveiewSiper.destroy();
              productReveiewSiper = new Swiper(".review-trending-swiper .swiper-container", {
              slidesPerView: 1,
              autoHeight: false, //enable auto height
              spaceBetween: 30,
              initialSlide:0,
              pagination: {
                el: ".slider__pagination",
                clickable: true,
              },
          });
         setTimeout(()=>{
            window.dispatchEvent(new Event("resize"));
          },100);
        }else if(targetNode.classList.contains("hw-abt-8-2")){
          productReveiewSiper = document.querySelector(".review-trending-swiper .swiper-container").swiper;
          productReveiewSiper.destroy();
          productReveiewSiper = new Swiper(".review-trending-swiper .swiper-container", {
            slidesPerView: 1,
            autoHeight: false, //enable auto height
            spaceBetween: 30,
            initialSlide:0,
            pagination: {
              el: ".slider__pagination",
              clickable: true,
            },
          });
          setTimeout(()=>{
            window.dispatchEvent(new Event("resize"));
          },100);
        }
        if(targetNode.classList.contains("hw-abt-12-1")){
           egswiperTiktok = document.querySelector(".eg-video-section .swiper-container").swiper;
           egswiperTiktok.destroy();
           egswiperTiktok = new Swiper('.eg-video-section .swiper-container', {
            // Optional parameters
              direction: 'horizontal',
              spaceBetween: 10,
              slidesPerView: 3,
              roundLengths: true,
              loop: false,
              breakpoints: {
                  1199: {
                      slidesPerView: 3,
                  },
                  991: {
                      slidesPerView: 3,
                  },
                  800: {
                      slidesPerView: 2.6,
                  },
                  500: {
                      slidesPerView: 1.4,
                  },
                320: {
                      slidesPerView: 1.4,
                  },
              },
              pagination: {
                  el: '.slider__pagination',
                  clickable: true,
              },
          });
          setTimeout(()=>{
            window.dispatchEvent(new Event("resize"));
          },100);
        }
        if(targetNode.classList.contains("hw-abt-16-1")){
            document.querySelectorAll('.upsell_slider').forEach(function(elem) {
              const flkity = Flickity.data(elem);
              flkity.destroy();
               upsell_slider = new Flickity(elem, {
                  cellAlign: 'left',
                  contain: true,
                  pageDots: true,
                  prevNextButtons: false,
                  wrapAround: true
              });
          });
        }
        if(targetNode.classList.contains("hw-abt-19-1")){
          if(theme.settings.abTest019 == 'test'){
            updateAB019ShippingContent();
          }
        }
        if(targetNode.classList.contains("hw-abt-20-1") || targetNode.classList.contains("hw-abt-20-2")){
          if(theme.settings.abTest020 == 'test'){
            checkSecondCrossOnCart();
            updateAB020Product();
          }
        }
        
        if(targetNode.classList.contains("hw-abt-23-1")){
          if(theme.settings.abTest023 == 'test'){
            updateAB023Product();
          }
        }
        if(targetNode.classList.contains("hw-abt-26-1")){
          updateAB026ProductPrice();
        }
        if(targetNode.classList.contains("hw-abt-27-2")){
          updateAB027Content();
        }
        /*if(targetNode.classList.contains("hw-abt-39-1")){
          if(theme.settings.abTest039 == 'test'){
            updateAB039LandingPage();
          }
        }*/ 
      }
    }
  };
  const observerforBody = new MutationObserver(callbackforBody);
  observerforBody.observe(targetNode, config);
}
const addSecondCrossProduct = async(id,isAdded) =>{
   if(isAdded == 1){
    let formData = {
     'items': [{
      'id': id,
      'quantity': 1,
      }]
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    document.querySelector(".cart-drawer-second-cross-sell input").setAttribute("data-isExist",true);
    document.querySelector(".cart-drawer-second-cross-sell input").setAttribute("data-key",data.items[0].key);
    document.dispatchEvent(new CustomEvent('cart:build'));
  }else{
     theme.cart.changeItem(id, 0)
    .then(function(cart) {
      document.querySelector(".cart-drawer-second-cross-sell input").setAttribute("data-isExist",false);
      document.querySelector(".cart-drawer-second-cross-sell input").setAttribute("data-key","");
       document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }
}
/*const updateAB039LandingPage = () => {
  if (theme.settings.abTest039 == 'test'){
    const wpn = window.location.pathname; //console.log(wpn);
    const wpu = wpn.split("/");
    const pg = wpu.pop(); //console.log(pg);
    if(document.body.classList.contains("hw-abt-39-1") && pg == 'winter-sale'){
      window.location.href = theme.settings.abTest039V1URL;
    }
  }
}*/
const updateAB023Product = () => {
  if (theme.settings.abTest023 == 'test'){
      const wpn = window.location.pathname; //console.log(wpn);
      const wpu = wpn.split("/");
      const pg = wpu.pop(); //console.log(pg);
    console.log(pg,"ddddddddd");
      if(document.body.classList.contains("hw-abt-23-1") && pg == 'loki'){
        window.location.href = 'https://northernknife.co.uk/products/loki-2';
      }
    }
}
const updateAB020Product = () => {
  if (theme.settings.abTest020 == 'test'){
      const wpn = window.location.pathname; //console.log(wpn);
      const wpu = wpn.split("/");
      const pg = wpu.pop(); //console.log(pg);
      if(document.body.classList.contains("hw-abt-20-1") && pg == 'knife-sharpener'){
        window.location.href = 'https://northernknife.co.uk/products/premium-knife-sharpener-2';
      }else if(document.body.classList.contains("hw-abt-20-1") && pg == 'premium-knife-sharpener-3'){
        window.location.href = 'https://northernknife.co.uk/products/premium-knife-sharpener-2';
      }else if(document.body.classList.contains("hw-abt-20-2") && pg == 'knife-sharpener'){
        window.location.href = 'https://northernknife.co.uk/products/premium-knife-sharpener-3';
      }else if(document.body.classList.contains("hw-abt-20-2") && pg == 'premium-knife-sharpener-2'){
        window.location.href = 'https://northernknife.co.uk/products/premium-knife-sharpener-3';
      }
    }
}
const updateAB026ProductPrice = () => {
  if(document.querySelector("body.hw-abt-26-1 .hide_compate_at_price_hw-abt-26 .first-variant-wrapper-div input:checked")){
    if(document.querySelector("body.hw-abt-26-1 .hide_compate_at_price_hw-abt-26 .product-block.product-block--price span.product__price.product__price--compare")){
      document.querySelector("body.hw-abt-26-1 .hide_compate_at_price_hw-abt-26 .product-block.product-block--price span.product__price.product__price--compare").classList.add("hide");
    }
  }else{
    if(document.querySelector("body.hw-abt-26-1 .hide_compate_at_price_hw-abt-26 .product-block.product-block--price span.product__price.product__price--compare")){
      document.querySelector("body.hw-abt-26-1 .hide_compate_at_price_hw-abt-26 .product-block.product-block--price span.product__price.product__price--compare").classList.remove("hide");
    }
  }
}
const checkSecondCrossOnCart = async() =>{
  if(document.querySelectorAll(".cart-drawer-second-cross-sell").length > 0){
    const inputElement = document.querySelector(".cart-drawer-second-cross-sell input");
    const priceElement = document.querySelector(".cart-drawer-second-cross-sell .second-item_price");
    let price = priceElement.dataset.price;
    let cprice = "";
    if(typeof priceElement.dataset.cprice !== 'undefined'){
      cprice = `<span>${priceElement.dataset.cprice}</span>`
    }
    let vid = inputElement.dataset.pid;
    if(theme.settings.abTest020 == 'v1' || (document.body.classList.contains('hw-abt-20-1') && theme.settings.abTest020 == 'test')){
      vid = inputElement.dataset.pid1;
      price = priceElement.dataset.price1;
      if(typeof priceElement.dataset.cprice1 !== 'undefined'){
        cprice = `<span>${priceElement.dataset.cprice1}</span>`
      }
    }else if(theme.settings.abTest020 == 'v2' || (document.body.classList.contains('hw-abt-20-2') && theme.settings.abTest020 == 'test')){
      vid = inputElement.dataset.pid2;
      price = priceElement.dataset.price2;
      if(typeof priceElement.dataset.cprice2 !== 'undefined'){
        cprice = `<span>${priceElement.dataset.cprice2}</span>`
      }
    }
    priceElement.innerHTML = `${price}${cprice}`;
    const response = await fetch("/cart.js",{
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const data = await response.json();
    
    if(data.item_count > 0){
      const matched = data.items.filter( item => item.id == vid);
      if(matched.length > 0){
        inputElement.setAttribute("data-isExist",true);
        inputElement.setAttribute("data-key",matched[0].key);
        inputElement.checked = true;
        //document.querySelector(`.cart__item[data-key="${matched[0].key}"]`).classList.add("hide-product");
      }else{
        inputElement.setAttribute("data-isExist",false);
        inputElement.setAttribute("data-key","");
        inputElement.checked = false;
      }
    }else{
      inputElement.setAttribute("data-isExist",false);
      inputElement.setAttribute("data-key","");
      inputElement.checked = false;
    }
  }
}
const upselbuttonInitlize = () =>{
  if(document.querySelectorAll('.form-upsell_button').length > 0){
    document.querySelectorAll('.form-upsell_button').forEach((el) =>{
      el.addEventListener("click", function(evt) {
        evt.preventDefault();
        let btnAddUpsell = el;
        let id = btnAddUpsell.getAttribute('data-id');

        btnAddUpsell.classList.add('btn--loading');

        let data = {
            items: [{
                id: id,
                quantity: 1
            }]
        };

        fetch(theme.routes.cartAdd, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(function(data) {
            if (data.status !== 422) {
                btnAddUpsell.classList.remove('btn--loading');
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: data,
                        addToCartBtn: btnAddUpsell
                    }
                }));
            }
        });
    
      });
    });
  }
  
}
function addScript() {
  var swiperScript = document.createElement('script');
  swiperScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js';
  document.getElementsByTagName('head')[0].appendChild(swiperScript);
}
waitForSwiper = function (trigger) {
    var interval = setInterval(function () {
        if (typeof Swiper != "undefined") {
            clearInterval(interval);
            trigger();
        }
    }, 50);
    setTimeout(function () {
        clearInterval(interval);
    }, 15000)
}
document.addEventListener("custom:updated",function(evt){
    initCustomDiscountEvent();
    checkFreeproductOncart();
   checkSecondCrossOnCart();
  upselbuttonInitlize();
});


class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute("end-date")).getTime();
    //this.shadow = this.attachShadow({ mode: "open" });
  }

  updateCountdown() {
    const now = new Date().getTime();
    const timeRemaining = this.endTime - now;

    if (timeRemaining <= 0) {
      // Countdown has ended, hide the element
      this.style.display = "none";
      document.querySelector(".countdown-wrapper").style.display="none";
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      /*this.innerHTML = `
        <div class="timer-item days-item"><span>${String(days).padStart(2, '0')}</span><span class="small-size">days</span></div>
        <div class="timer-item hours-item"><span>${String(hours).padStart(2, '0')}</span><span class="small-size">hours</span></div>
        <div class="timer-item minutes-item"><span>${String(minutes).padStart(2, '0')}</span><span class="small-size">minutes</span></div>
        <div class="timer-item seconds-items"><span>${String(seconds).padStart(2, '0')}</span><span class="small-size">seconds</span></div>
      `;*/
      this.querySelector(".days-counter").innerHTML = String(days).padStart(2, '0');
      this.querySelector(".hours-counter").innerHTML = String(hours).padStart(2, '0');
      this.querySelector(".minutes-counter").innerHTML = String(minutes).padStart(2, '0');
      this.querySelector(".seconds-counter").innerHTML = String(seconds).padStart(2, '0');
    }
  }
  addHTML(){
     this.innerHTML = `
        <div class="timer-item days-item"><span class="days-counter">${String(0).padStart(2, '0')}</span><span class="small-size">days</span></div>
        <div class="timer-item hours-item"><span class="hours-counter">${String(0).padStart(2, '0')}</span><span class="small-size">hours</span></div>
        <div class="timer-item minutes-item"><span class="minutes-counter">${String(0).padStart(2, '0')}</span><span class="small-size">minutes</span></div>
        <div class="timer-item seconds-items"><span class="seconds-counter">${String(0).padStart(2, '0')}</span><span class="small-size">seconds</span></div>`;
    
  }
  connectedCallback() {
    this.addHTML();
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

if (!customElements.get('countdown-timer')) {
      customElements.define("countdown-timer", CountdownTimer);
}
function updateTimerForCart() {
    // Get the current date and time
    let now = new Date();

    // Set the future date to the next midnight
    let future = new Date(now);
    future.setHours(24, 0, 0, 0); // Set to midnight of the next day

    // Calculate the difference in milliseconds
    let diff = future - now;

    // Calculate time components
    let totalHours = Math.floor(diff / (1000 * 60 * 60));
    let mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    let secs = Math.floor((diff % (1000 * 60)) / 1000);

    if(document.querySelector(".cart-drawer-timer-wrapper #timer")){
      // Display the result in the respective div
      document.querySelector(".cart-drawer-timer-wrapper #timer").innerHTML =
        '<div class="time">' + String(totalHours).padStart(2, '0') + '<label>HOURS</label></div>' + ':' +
        '<div class="time">' + String(mins).padStart(2, '0') + '<label>MINUTES</label></div>' + ':' +
        '<div class="time">' + String(secs).padStart(2, '0') + '<label>SECONDS</label></div>';
    }
    
}

function updateTimers() {
    // Get the current date and time
    let now = new Date();

    // Set the future date to the next midnight
    let future = new Date(now);
    future.setHours(24, 0, 0, 0); // Set to midnight of the next day

    // Calculate the difference in milliseconds
    let diff = future - now;

    // Calculate time components
    let totalHours = Math.floor(diff / (1000 * 60 * 60));
    let mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    let secs = Math.floor((diff % (1000 * 60)) / 1000);

    // Display the result in the respective div
  if(document.getElementById("timers")){
     document.getElementById("timers").innerHTML =
        '<div class="time">' + String(totalHours).padStart(2, '0') + '<label>HOURS</label></div>' + ':' +
        '<div class="time">' + String(mins).padStart(2, '0') + '<label>MINUTES</label></div>' + ':' +
        '<div class="time">' + String(secs).padStart(2, '0') + '<label>SECONDS</label></div>';
  }
   
}


const initilizeCustomSubFilterSlider = () => {
  const customSwiper2 = new Swiper(".custom-filter-3-wrapper .swiper-container", {
      centeredSlides: true,
    centeredSlidesBounds: true,
    slideToClickedSlide:true,
    loop:true,
    slidesPerView: 5,
    spaceBetween: 10,
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    breakpoints: {
      // when window width is >= 320px
      791: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      600: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      550: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      450: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      380: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      0: {
        slidesPerView: 3,
        spaceBetween: 10
      }
    }
  });
  customSwiper2.on('slideChangeTransitionEnd', function (evt) {
    const realIndex = evt.activeIndex;
    const slide = evt.slides[realIndex];
    console.log("slide changed",slide,realIndex,evt);
    const labelElementTrigger =  slide.querySelector(".custom-filter-box").getAttribute("for");
    document.querySelector(`.filter-form #${labelElementTrigger}`).parentNode.click();
  });
}
const initilizeCustomFilterSlider = ()=>{
  const customSwiper = new Swiper(".custom-filter-1-wrapper .swiper-container", {
    centeredSlides: true,
    centeredSlidesBounds: true,
    slideToClickedSlide:true,
    loop:true,
    slidesPerView: 5,
    spaceBetween: 20,
     navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      791: {
        slidesPerView: 5,
        spaceBetween: 20
      },
      600: {
        slidesPerView: 4,
        spaceBetween: 24
      },
      550: {
        slidesPerView: 3.5,
        spaceBetween: 27
      },
      450: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      380: {
        slidesPerView: 2.5,
        spaceBetween: 25
      },
      0: {
        slidesPerView: 2.7,
        spaceBetween: 22
      }
    }
  });
  customSwiper.on('slideChangeTransitionEnd', function (evt) {
    const realIndex = evt.activeIndex;
    const slide = evt.slides[realIndex];
    console.log("slide changed",slide,realIndex,evt);
    const labelElementTrigger =  slide.querySelector(".custom-filter-box").getAttribute("for");
    document.querySelector(`.filter-form #${labelElementTrigger}`).parentNode.click();
  });

  initilizeCustomSubFilterSlider();
   const subcollectionFilterElement = document.querySelector("#CollectionSubFilterAjax");
  if(document.querySelectorAll(`.swiper-slide-active label.custom-filter-box[data-value="SHOP ALL"]`).length > 0){
    subcollectionFilterElement.classList.add("hide");
  }else{
    subcollectionFilterElement.classList.remove("hide");
  }
}

const collectionSubFilterEvents = () => {
  const subcollectionFilterElement = document.querySelector("#CollectionSubFilterAjax");
  if(subcollectionFilterElement){
    if(document.querySelectorAll(`.swiper-slide-active label.custom-filter-box[data-value="SHOP ALL"]`).length > 0){
      subcollectionFilterElement.classList.add("hide");
    }else{
      subcollectionFilterElement.classList.remove("hide");
    }
  }
  
  if(document.querySelectorAll(".custom-filter-2-wrapper").length > 0 && document.querySelectorAll(".custom-filter-2-wrapper label.custom-filter-box.eg-active").length > 0){
      const acItem2 = document.querySelector(".custom-filter-2-wrapper label.custom-filter-box.eg-active");
      let tabwidth2 = acItem2.offsetWidth;
      document.querySelector(".eg-tabs-nav__position-2").style.cssText = '--width:' + tabwidth2 + 'px;--prevWidth:' + (acItem2.offsetLeft) + 'px;';
      acItem2.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    if(document.querySelectorAll(`.custom-filter-2-wrapper .custom-filter-box:not(.hide)`).length > 0){
      document.querySelector(".custom-filter-2-wrapper").classList.remove("hide");
    }else{
      document.querySelector(".custom-filter-2-wrapper").classList.add("hide");
    }
  }
     if(document.querySelectorAll(".custom-filter-2-wrapper").length > 0 ){
       document.querySelectorAll(".custom-filter-2-wrapper label.custom-filter-box").forEach((el) => {
         el.addEventListener("click",(evt) => {
            document.querySelectorAll(".custom-filter-2-wrapper label.custom-filter-box").forEach(el2 => el2.classList.remove("eg-active"));
            el.classList.add("eg-active");
            let tabwidth2 = el.offsetWidth;
            document.querySelector(".eg-tabs-nav__position-2").style.cssText = '--width:' + tabwidth2 + 'px;--prevWidth:' + (el.offsetLeft) + 'px;';
            el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
         });
       });
     }

  if(document.querySelectorAll("#CustomAjaxActiveFilters .tag--remove").length <= 0){
    if(document.querySelector(`.custom-filter-1-wrapper .swiper-container.swiper-initialized .custom-filter-box[data-value="SHOP ALL"]`) && document.querySelector(`.custom-filter-1-wrapper .swiper-container.swiper-initialized .custom-filter-box[data-value="SHOP ALL"]`).parentElement.classList.contains("swiper-slide-active") === false){
       document.querySelector(".custom-filter-1-wrapper .swiper-container").swiper.slideTo(3);
    }
   
    //document.querySelector(`.custom-filter-1-wrapper .swiper-container .custom-filter-box[data-value="SHOP ALL"]`).click();
  }
}
const updateAB019ShippingContent = () => {
 
  if(theme.settings.abTest019 == 'v1' || (document.body.classList.contains('hw-abt-19-1') && theme.settings.abTest019 == 'test')){
    if(document.querySelectorAll(".theridge-promoBanner__wrapper").length > 0){
      const cloneHeaderAnnoument = document.querySelector(".theridge-promoBanner__wrapper").cloneNode(true);
      const headerAnnoument = document.querySelector(".theridge-promoBanner__wrapper");
      headerAnnoument.children[1].innerHTML = headerAnnoument.children[1].innerHTML.replace("FREE SHIPPING","FREE SHIPPING OVER £50");
    }
    if(document.body.classList.contains('template-product')){
      const productBlocks = document.querySelectorAll('div.product-block--tab');
      if(productBlocks.length > 0){

          const lastblock = productBlocks[productBlocks.length-1];
          lastblock.children[0].children[1].children[0].innerHTML = lastblock.children[0].children[1].children[0].innerHTML.replace("orders.","orders over £50");
         console.log("updateAB019ShippingContent",lastblock);
        //lastblock.children[0].children[1].children[0].innerHTML = lastblock.children[0].children[1].children[0].innerHTML.replace("Orders.","Orders over £50.");
        /*if(document.querySelector("#Product-content-ff6479c4-21f2-4ba1-9bd5-159aea19b28e8152261001523")){
          document.querySelector("#Product-content-ff6479c4-21f2-4ba1-9bd5-159aea19b28e8152261001523").innerHTML = document.querySelector("#Product-content-ff6479c4-21f2-4ba1-9bd5-159aea19b28e8152261001523").innerHTML.replace("orders.","orders over 50£");
        }
        if(document.querySelector("#Product-content-ff6479c4-21f2-4ba1-9bd5-159aea19b28e8152505614643")){
          document.querySelector("#Product-content-ff6479c4-21f2-4ba1-9bd5-159aea19b28e8152505614643").innerHTML = document.querySelector("#Product-content-ff6479c4-21f2-4ba1-9bd5-159aea19b28e8152505614643").innerHTML.replace("orders.","orders over 50£");
        }*/
              
      }
      const secureBadge = document.querySelector('.atc-secureBadge');
      //secureBadge.children[0].remove();
      secureBadge.children[0].querySelector('span').innerHTML = secureBadge.children[0].querySelector('span').innerHTML.replace(" Shipping"," Shipping over £50");
      
    }
    if(window.location.pathname.includes("faq")){
      if(document.querySelector("#FAQ-content-1633440525fc19fc1e-1 p")){
        //document.querySelector("#FAQ-content-1633440525fc19fc1e-1 p").innerHTML = document.querySelector("#FAQ-content-1633440525fc19fc1e-1 p").innerHTML.replace("Royal Mail.","Royal Mail 2.90 GBP.")
        //document.querySelector("#FAQ-content-1633440525fc19fc1e-1 p").textContent = `We send out all orders via 2.90 GBP standard shipping with Royal Mail.`;
        document.querySelector("#FAQ-content-1633440525fc19fc1e-1 p").innerHTML = document.querySelector("#FAQ-content-1633440525fc19fc1e-1 p").innerHTML.replace("Royal Mail.","Royal Mail over £50.");
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  updateAB027Content();
  if(theme.settings.abTest019 == 'v1'){
     console.log("DOMContentLoaded","DOMContentLoaded");
    updateAB019ShippingContent();
  }

  if(document.body.classList.contains("hw-abt-26-1")){
    updateAB026ProductPrice();
  }
  if(document.querySelector(".cart-drawer-timer-wrapper #timer")){
    // Update the timer every second
    setInterval(updateTimerForCart, 1000);
    
    // Initial call to set the timer immediately
    updateTimerForCart();
  }
  
  if(document.getElementById("timers")){
    // Update the timer every second
    setInterval(updateTimers, 1000);
    
    // Initial call to set the timer immediately
  updateTimers();
  }
  if(document.querySelectorAll(".cart-drawer-second-cross-sell").length > 0){
    document.querySelector(".cart-drawer-second-cross-sell input").addEventListener("change",async(evt)=>{
        console.log(evt,"evnt",evt.target.dataset.isexist === 'false');
        let vid = evt.target.dataset.pid;
        if(theme.settings.abTest020 == 'v1' || (document.body.classList.contains('hw-abt-20-1') && theme.settings.abTest020 == 'test')){
          vid = evt.target.dataset.pid1;
        }else if(theme.settings.abTest020 == 'v2' || (document.body.classList.contains('hw-abt-20-2') && theme.settings.abTest020 == 'test')){
          vid = evt.target.dataset.pid2;
        }
        if(evt.target.checked == true && evt.target.dataset.isexist === 'false'){
          
          await addSecondCrossProduct(vid,1);
        }else{
          await addSecondCrossProduct(vid,0);
        }
    });
  }
  
  if(document.querySelectorAll(".product-slideshow").length > 0){
    if(document.querySelectorAll(".product-slideshow.custom-mode--test .product__thumb-item.ab-testing").length > 0){
       const flkity = Flickity.data(document.querySelector(".product-slideshow"));
       flkity.cells[1].element.style.display="none";
       flkity.cells[2].element.style.display="none";
       flkity.reloadCells();
    }else if(document.querySelectorAll(".product-slideshow.custom-mode--v1 .product__thumb-item.ab-testing").length > 0){
       const flkity = Flickity.data(document.querySelector(".product-slideshow"));
       flkity.cells[2].element.style.display="none";
       flkity.reloadCells();
    }else if(document.querySelectorAll(".product-slideshow.custom-mode--v2 .product__thumb-item.ab-testing").length > 0){
       const flkity = Flickity.data(document.querySelector(".product-slideshow"));
       flkity.cells[1].element.style.display="none";
       flkity.reloadCells();
    }
    
  }
  initializeBodyObservation();
  
  if(document.querySelectorAll(".grand-child-link-rigger.slide-menu-option-sub-open-trigger").length > 0){
    document.querySelectorAll(".grand-child-link-rigger.slide-menu-option-sub-open-trigger").forEach( (el) => {
        el.addEventListener("click", (evt) => {
          evt.preventDefault();
          const dataId = evt.currentTarget.dataset.slug
          document.querySelectorAll(".custom-container-menu").forEach( (el2) => {
            el2.classList.remove("active");
           //theme.utils.prepareTransition(el2,function(){
             // el2.classList.remove("active");
            //});
          });
          const el = document.querySelector(`.custom-container-menu[data-slug="${dataId}"]`);
          theme.utils.prepareTransition(el,function(){
            el.classList.add("active");
          });
          return false;
        });
    });
    document.querySelectorAll(".custom-container-menu .back-button").forEach( (el) => {
        el.addEventListener("click", (evt) => {
          evt.preventDefault();
          document.querySelectorAll(".custom-container-menu").forEach( (el2) => {
            el2.classList.remove("active");
          });
        });
    });
    
  }
  if(document.querySelectorAll(".custom-collection-main-bfcm .custom-filter-box").length > 0){
    document.querySelectorAll(".custom-collection-main-bfcm .custom-filter-box").forEach( (el) => {
        el.addEventListener("click", (evt) => {
          evt.preventDefault();
          const dataId = evt.currentTarget.dataset.id
          document.querySelectorAll(".filter-items").forEach( (el) => {
            el.classList.add("hide");
          });
          document.querySelectorAll(".custom-collection-main-bfcm .custom-filter-box").forEach( (el) => {
            el.classList.remove("active");
          });
          evt.currentTarget.classList.add("active");
          document.querySelector(`.filter-items[id="${dataId}"]`).classList.remove("hide");
        });
    });
  }
  if(document.querySelectorAll(".customAjaxForm").length > 0){
    const allForms = document.querySelectorAll(".customAjaxForm");
    allForms.forEach( (currentForm) => {
      currentForm.addEventListener("submit",function(evt){
        evt.preventDefault();
        const formElement = evt.target;
        const addToCart = formElement.querySelector(".add-to-cart");
        addToCart.classList.add('btn--loading');
        var data = theme.utils.serialize(formElement);

        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          var product = data;
          var id = product.id;
          
         
            let upsellData = addToCart.getAttribute('data-upsells').replace(/ /g,'').replace(/\t/g, '');
            let upsells_to_append;

            if(upsellData){
              upsells_to_append = upsellData.split(',');
              if(upsells[id] != null){
                upsells[id][0] = upsells[id][0] + 1;
              } else {
                let data_upsell_status = {};
                data_upsell_status = {
                  count: 1,
                  upsells: upsells_to_append
                };
                upsells[id] = data_upsell_status;
              }
            } else {
              let data_upsell_status = {};
              data_upsell_status = {
                count: 1,
                upsells: null
              }
              upsells[id] = data_upsell_status;
            }

            console.log(upsells);
            //theme.cart.generateUpsells(upsells);

            localStorage.setItem('upsells', JSON.stringify(upsells));
          
           document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: product,
              addToCartBtn: addToCart
            }
          }));
        addToCart.classList.remove('btn--loading');
        return false;
      });
    });
     });
  }
  if(document.querySelectorAll(".upsell_slider").length > 0){
     document.querySelectorAll('.upsell_slider').forEach(function(elem) {
         upsell_slider = new Flickity(elem, {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true
        });
    });
  }
  // Select the element with the class 'sale-price'
  const salePriceElement = document.querySelector('.grid-overflow-wrapper .sale-price');
  
  // Check if the element exists
  if (salePriceElement) {
    // Get the current text content of the element
    let textContent = salePriceElement.textContent;
    
    // Remove the word 'from' from the text content
    textContent = textContent.replace('from ', '');
    
    // Set the modified text content back to the element
    salePriceElement.textContent = textContent;
  }
  
  Flickity.prototype._createResizeClass = function() {
    this.element.classList.add('flickity-resize');
  };

  Flickity.createMethods.push('_createResizeClass');

  var resize = Flickity.prototype.resize;
  Flickity.prototype.resize = function() {
    this.element.classList.remove('flickity-resize');
    resize.call( this );
    this.element.classList.add('flickity-resize');
  };
  var dropdownLinks = document.querySelectorAll('.site-nav .dropdown-content a');
  dropdownLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
          event.preventDefault();
          var countryURL = this.getAttribute('href');
          window.location.href = countryURL;
      });
  });

 if(document.querySelectorAll(".custom-collection-main-bfcm .custom-filter-box").length > 0){
    document.querySelectorAll(".custom-collection-main-bfcm .custom-filter-box a").forEach( (el) => {
      var filter_url = el.href;
      var siteurl = window.location.pathname;
      console.log(filter_url.includes(siteurl));
      if(filter_url.includes(siteurl)){
        el.classList.add("active");
      }else{
        el.classList.remove("active");
      }
    });
  }
  // Toggle dropdown menu
    document.querySelectorAll(".site-nav.site-nav--icons .dropdown button.dropbtn").forEach(function(button) {
        button.addEventListener("click", function() {
            document.querySelectorAll(".site-nav.site-nav--icons .dropdown .dropdown-content").forEach(function(content) {
                content.classList.toggle("active");
            });
        });
    });

    // Initialize custom filter slider if exists
    if (document.querySelectorAll(".custom-filter-1-wrapper").length > 0) {
        initilizeCustomFilterSlider();
    }

    // Add or remove darkHeader class on scroll
    if(document.querySelector(".collection-custom-filter")){
       window.addEventListener("scroll", function() {
          if (window.scrollY >= 1000) {
              document.querySelector(".collection-custom-filter").classList.add("darkHeader");
          } else {
              document.querySelector(".collection-custom-filter").classList.remove("darkHeader");
          }
      });
    }
   

    // Add product to cart via upsell button
    upselbuttonInitlize();

    // Toggle grid layout for collection
    if(document.querySelector(".left-grid-icon")){
       document.querySelector(".left-grid-icon").addEventListener("click", function() {
          document.getElementById('CollectionAjaxContent').classList.add('columns-3-grid');
          document.getElementById('CollectionAjaxContent').classList.remove('columns-4-grid');
          document.querySelector('.left-grid-icon').classList.add('active');
          document.querySelector('.right-grid-icon').classList.remove('active');
      });
    }
   
    if(document.querySelector(".right-grid-icon")){
      document.querySelector(".right-grid-icon").addEventListener("click", function() {
          document.getElementById('CollectionAjaxContent').classList.add('columns-4-grid');
          document.getElementById('CollectionAjaxContent').classList.remove('columns-3-grid');
          document.querySelector('.right-grid-icon').classList.add('active');
          document.querySelector('.left-grid-icon').classList.remove('active');
      });
    }
    

    // Hide sticky add to cart on click
    if(document.querySelector('.sticky-atc')){
      document.querySelector('.sticky-atc').addEventListener('click', function() {
          document.querySelector('.sticky-addtocart').style.display = 'none';
      });
    }
    

    // Scroll to top on button click
    const buttonScrollToTop = document.querySelector("#buttonScrollToTop");
    if (buttonScrollToTop) {
        buttonScrollToTop.addEventListener("click", function() {
            window.scrollTo({ top: 450, behavior: 'smooth' });
        });
    }
  if(document.querySelectorAll(".review-trending-swiper .swiper-container").length > 0){
    const currentSlide = document.querySelector(".review-trending-swiper .swiper-container").dataset.currentslide;
    productReveiewSiper = new Swiper(".review-trending-swiper .swiper-container", {
        slidesPerView: 1,
        autoHeight: true, //enable auto height
        spaceBetween: 30,
        initialSlide:currentSlide,
        pagination: {
          el: ".slider__pagination",
          clickable: true,
        },
      });
  }
  if(document.querySelectorAll(".eg-video-section .swiper-container").length > 0){
  egswiperTiktok = new Swiper('.eg-video-section .swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        roundLengths: true,
        loop: false,
        breakpoints: {
            1199: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 3,
            },
            800: {
                slidesPerView: 2.6,
            },
            500: {
                slidesPerView: 1.4,
            },
          320: {
                slidesPerView: 1.4,
            },
        },
        pagination: {
            el: '.slider__pagination',
            clickable: true,
        },
    });
  }

  if(document.querySelectorAll(".custom-review-section-slider-main").length > 0){
    const customReveiewSiper = new Swiper(".custom-review-section-slider-main", {
        slidesPerView: 1,
        loop:true,
        navigation: {
            nextEl: '.custom-review-section-slider-main .swiper-button-next',
            prevEl: '.custom-review-section-slider-main .swiper-button-prev',
        },
        pagination: {
            el: '.custom-review-section-slider-main .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            767: {
                slidesPerView: 3,
                 spaceBetween: 20,
            },
            
        }
      });
  }

  // Select all dropdown containers
  const dropdowns = document.querySelectorAll('.dropdown');
  
  dropdowns.forEach(dropdown => {
      const dropdownButton = dropdown.querySelector('.dropbtn');
      const dropdownContent = dropdown.querySelector('.dropdown-content');
      const countryCodeElement = dropdownButton.querySelector('.country-code');
      const flagElement = dropdownButton.querySelector('.flag');
      
      console.log(dropdownButton); // Check if the dropdown button is correctly selected
      console.log(countryCodeElement); // Check if the country code element is correctly selected
      console.log(flagElement); // Check if the flag element is correctly selected
      
      // Toggle dropdown on button click
      dropdownButton.addEventListener('click', () => {
          dropdownContent.classList.toggle('show');
      });
      
      // Handle selection from dropdown items
      dropdownContent.querySelectorAll('a').forEach(item => {
          item.addEventListener('click', (e) => {
              e.preventDefault();
              const country = item.getAttribute('data-country');
              const flag = item.getAttribute('data-flag');
              
              console.log(country); // Log the selected country
              console.log(flag); // Log the selected flag
              
              if (countryCodeElement && flagElement) {
                  countryCodeElement.textContent = country;
                  flagElement.src = flag;
                  console.log(`Updated country code: ${countryCodeElement.textContent}`); // Verify the update
                  console.log(`Updated flag src: ${flagElement.src}`); // Verify the update
              }
              
              dropdownContent.classList.remove('show');
          });
      });
  });
  
  // Close all dropdowns if the user clicks outside of them
  window.addEventListener('click', (e) => {
      dropdowns.forEach(dropdown => {
          const dropdownButton = dropdown.querySelector('.dropbtn');
          const dropdownContent = dropdown.querySelector('.dropdown-content');
          
          if (!dropdownButton.contains(e.target) && !dropdownContent.contains(e.target)) {
              dropdownContent.classList.remove('show');
          }
      });
  });
});
document.addEventListener("DOMContentLoaded", function() {
  const allVideoPauseButtons = document.querySelectorAll(".video-pause");
  if(allVideoPauseButtons.length > 0){
    allVideoPauseButtons.forEach((button) => {
      button.addEventListener("click",(evt) => {
        const parentElement = button.closest(".custom-media-wrapper");
        const video = parentElement.querySelector("video");
        video.pause();
        button.classList.add("hide");
        parentElement.querySelector(".video-play").classList.remove("hide");
      });
    });
  }
  const allVideoPlayButtons = document.querySelectorAll(".video-play");
  if(allVideoPlayButtons.length > 0){
    allVideoPlayButtons.forEach((button) => {
      button.addEventListener("click",(evt) => {
        const parentElement = button.closest(".custom-media-wrapper");
        const video = parentElement.querySelector("video");
        video.play();
        button.classList.add("hide");
        parentElement.querySelector(".video-pause").classList.remove("hide");
      });
    });
  }

  /*const pdpEngraveButton = document.querySelector(".custom-engrave-button-pdp-btn");
   const enrgaveCancelButton = document.querySelector(".custom-engrave-button-pdp-btn-cancel");
    const enagraveTextInput = document.querySelector(".engrave-text-input");
    if(pdpEngraveButton){
      pdpEngraveButton.addEventListener("click",() => {
        pdpEngraveButton.classList.add("hide");
        enrgaveCancelButton.classList.remove("hide");
        enagraveTextInput.classList.remove("hide");
      });
      enrgaveCancelButton.addEventListener("click",() => {
        pdpEngraveButton.classList.remove("hide");
        enrgaveCancelButton.classList.add("hide");
        enagraveTextInput.classList.add("hide");
        enagraveTextInput.value = "";
        document.querySelector(".add-to-cart .product__price").textContent = enagraveTextInput.dataset.price;
        document.querySelector(".product-single__variants").value = enrgaveCancelButton.dataset.variant;
      });
      enagraveTextInput.addEventListener("input",() => {
        if(enagraveTextInput.value.length > 0){
          document.querySelector(".add-to-cart .product__price").textContent = enagraveTextInput.dataset.eprice;
          document.querySelector(".product-single__variants").value = enagraveTextInput.dataset.variant;
        }else{
          document.querySelector(".add-to-cart .product__price").textContent = enagraveTextInput.dataset.price;
          document.querySelector(".product-single__variants").value = enrgaveCancelButton.dataset.variant;
        }
      });
    }*/
  
    if(document.querySelectorAll(".knife-view-specs").length > 0){
      document.querySelectorAll(".knife-view-specs").forEach((el) => {
         
        el.addEventListener("click",() => {
             const popupid = el.dataset.id;
            if(document.querySelectorAll(".ragnar-popup-overlay").length > 0){
              document.querySelectorAll(".ragnar-popup-overlay").forEach((el2) => {
                el2.classList.remove("active-popup");
              });
              if(document.querySelector(`.ragnar-popup-overlay[data-id="${popupid}"]`)){
                document.querySelector(`.ragnar-popup-overlay[data-id="${popupid}"]`).classList.add("active-popup");
              }
            }
        });
          
      });
     if(document.querySelectorAll(".ragnar-popup-overlay").length > 0){
          
       document.querySelectorAll(".ragnar-popup-overlay").forEach((el2) => {
        el2.addEventListener('click', function(e) {
            if (e.target === this) {
                this.classList.remove('active-popup');
            }
        });
       });
        document.querySelectorAll(".ragnar-popup-overlay .ragnar-knife-popup-close").forEach((el) => {
        el.addEventListener('click', function(e) {
            document.querySelectorAll(".ragnar-popup-overlay").forEach((el2) => {
                el2.classList.remove("active-popup");
              });
        });
       });
       
     }
    }
    if(document.querySelectorAll(".custom-tab-items .custom-tab-item").length > 0){
      document.querySelectorAll(".custom-tab-items .custom-tab-item").forEach((el) => {
        el.addEventListener("click",(evt) => {
            const mainElement = el.closest(".custom-tab-items");
            mainElement.querySelectorAll(".custom-tab-item").forEach((el2) => {
              el2.classList.remove("active-tab");
              document.querySelector(`.custom-tabs-main-content-wrapper .custom-tab-pack[id="${el2.dataset.target}"]`).classList.add("hide");
            });
            el.classList.add("active-tab");
          document.querySelector(`.custom-tabs-main-content-wrapper .custom-tab-pack[id="${el.dataset.target}"]`).classList.remove("hide");
        });
      })
    }
    // Toggle dropdown menu
    document.querySelectorAll(".site-nav.site-nav--icons .dropdown button.dropbtn").forEach(function(button) {
        button.addEventListener("click", function() {
            document.querySelectorAll(".site-nav.site-nav--icons .dropdown .dropdown-content").forEach(function(content) {
                content.classList.toggle("active");
            });
        });
    });

    // Initialize custom filter slider if exists
    if (document.querySelectorAll(".custom-filter-1-wrapper").length > 0) {
        initilizeCustomFilterSlider();
    }

    // Add or remove darkHeader class on scroll
    if(document.querySelector(".collection-custom-filter")){
       window.addEventListener("scroll", function() {
          if (window.scrollY >= 1000) {
              document.querySelector(".collection-custom-filter").classList.add("darkHeader");
          } else {
              document.querySelector(".collection-custom-filter").classList.remove("darkHeader");
          }
      });
    }
   

    // Add product to cart via upsell button
    upselbuttonInitlize();

    // Toggle grid layout for collection
    if(document.querySelector(".left-grid-icon")){
       document.querySelector(".left-grid-icon").addEventListener("click", function() {
          document.getElementById('CollectionAjaxContent').classList.add('columns-3-grid');
          document.getElementById('CollectionAjaxContent').classList.remove('columns-4-grid');
          document.querySelector('.left-grid-icon').classList.add('active');
          document.querySelector('.right-grid-icon').classList.remove('active');
      });
    }
   
    if(document.querySelector(".right-grid-icon")){
      document.querySelector(".right-grid-icon").addEventListener("click", function() {
          document.getElementById('CollectionAjaxContent').classList.add('columns-4-grid');
          document.getElementById('CollectionAjaxContent').classList.remove('columns-3-grid');
          document.querySelector('.right-grid-icon').classList.add('active');
          document.querySelector('.left-grid-icon').classList.remove('active');
      });
    }
    

    // Hide sticky add to cart on click
    if(document.querySelector('.sticky-atc')){
      document.querySelector('.sticky-atc').addEventListener('click', function() {
          document.querySelector('.sticky-addtocart').style.display = 'none';
      });
    }
    

    // Scroll to top on button click
    const buttonScrollToTop = document.querySelector("#buttonScrollToTop");
    if (buttonScrollToTop) {
        buttonScrollToTop.addEventListener("click", function() {
            window.scrollTo({ top: 450, behavior: 'smooth' });
        });
    }
    const customBYSOpeners = document.querySelectorAll(".bys-product-selector");
    if(customBYSOpeners.length > 0){
      customBYSOpeners.forEach((el) => {
        el.addEventListener("click",(evt) => {
            const product_id = el.dataset.product;
            const type = el.dataset.type;
            if(type == 'v1' || (type == 'test' && document.body.classList.contains('hw-abt-38-1'))){
              window.location = el.dataset.href;
            }else if(type == 'v2' || (type == 'test' && document.body.classList.contains('hw-abt-38-2'))){
              document.querySelectorAll(".custom-center-popup").forEach((item) => {
                if(item.dataset.product == product_id){
                   item.classList.add("open");
                  document.body.classList.add("custom-pack-modal-opened");
                }else{
                   item.classList.remove("open");
                }
               
            });
            }
            
        });
      });
    }
    const modalOpeners = document.querySelectorAll(".custom-modal-opener");
    if(modalOpeners.length > 0){
      modalOpeners.forEach((el) => {
        el.addEventListener("click",(evt) => {
            const product_id = el.dataset.product;
            document.querySelectorAll(".custom-center-popup").forEach((item) => {
                if(item.dataset.product == product_id){
                   item.classList.add("open");
                  document.body.classList.add("custom-pack-modal-opened");
                }else{
                   item.classList.remove("open");
                }
               
            });
        });
      });
    }
    if(document.querySelectorAll(".closeModalButton").length > 0){
      document.querySelectorAll(".closeModalButton").forEach((el) => {
         el.addEventListener("click",(evt) => {
            document.querySelectorAll(".custom-center-popup.open").forEach((item) => {
               item.classList.remove("open");
               document.body.classList.remove("custom-pack-modal-opened");
            });
         });
      });
    }
    if(document.querySelectorAll(".pack-filter-anchors-item").length > 0){
      document.querySelectorAll(".pack-filter-anchors-item").forEach((el) => {
          el.addEventListener("click",(evt) => {
            const datatarget = el.dataset.target;
            //const targetedElement = document.querySelector(`div[data-identifier="${datatarget}"]`);
            const targetedElement = getVisibleSection(datatarget);
            if(targetedElement){
              targetedElement.scrollIntoView({ block: 'start', inline: 'start',behavior: 'smooth' });
  
            }
          });
      });
    }
});
function getVisibleSection(identifier) {
    var elements = document.querySelectorAll(`div[data-identifier="${identifier}"]`);

    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        // Check if element is visible
        if (element.offsetParent !== null && 
            window.getComputedStyle(element).display !== 'none' && 
            window.getComputedStyle(element).visibility !== 'hidden') {
            return element;
        }
    }

    return null;
}
document.addEventListener("variant:change",(evt) => {
  if(document.body.classList.contains("hw-abt-26-1")){
    updateAB026ProductPrice();
  }
  const variant = evt.detail.variant;
  console.log(variant,"variantvariant");
  const elementOfEngrave = document.querySelector(".custom-engrave-text-wrapper");
  const enrgaveCancelButton = document.querySelector(".custom-engrave-button-pdp-btn-cancel");
  if(elementOfEngrave){
    const engrvaeVariantJSON = JSON.parse(document.querySelector(".custom-engrave-variant-json-template").innerHTML);
    const findMatch = engrvaeVariantJSON.variants.filter(item => item.id == variant.id && item.is_engave == true);
    if(findMatch.length > 0){
      elementOfEngrave.classList.remove("hide");
      if(enrgaveCancelButton){
        enrgaveCancelButton.dataset.variant = findMatch[0].id;
      }
    }else{
      elementOfEngrave.classList.add("hide");
      elementOfEngrave.querySelector("input").value="";
    }
  }
});

const collectionDropInWidget = () => {
  // Find all product cards or containers
  const productCards = document.querySelectorAll('.grid__item.grid-product');
  
  // If no specific product cards found, look for release buttons directly
  const releaseButtons = document.querySelectorAll('.dropin-widget-button[data-date]');
  
  // Store active intervals for cleanup
  const activeIntervals = new Map();
  
  // Function to find the corresponding ATC button for a release button
  function findCorrespondingATCButton(releaseButton) {
    // Look for ATC button in the same parent container
    const parentCard = releaseButton.closest('.grid__item.grid-product');
    
    if (parentCard) {
      // Look for ATC button in the same card
      return parentCard.querySelector('.add-to-cart');
    }
    
    // Fallback: look for sibling ATC button
    const nextSibling = releaseButton.nextElementSibling;
    if (nextSibling && (nextSibling.classList.contains('btn') || nextSibling.classList.contains('add-to-cart'))) {
      return nextSibling;
    }
    
    // Another fallback: look in parent for any ATC button
    const parent = releaseButton.parentElement;
    return parent ? parent.querySelector('.add-to-cart') : null;
  }
  
  // Function to create countdown for a specific release button
  function createCountdownForButton(releaseButton) {
    const dateString = releaseButton.getAttribute('data-date');
    const buttonId = releaseButton.getAttribute('data-button-id') || `btn-${Math.random().toString(36).substr(2, 9)}`;
    
    // Set button ID if not present
    if (!releaseButton.getAttribute('data-button-id')) {
      releaseButton.setAttribute('data-button-id', buttonId);
    }
    
    // Find the corresponding ATC button
    const atcButton = findCorrespondingATCButton(releaseButton);
    
    // Initially hide the ATC button
    if (atcButton) {
      atcButton.classList.add('hide');
    }
    
    // Parse the date
    let targetDate;
    
    if (dateString.includes('T')) {
      // Full datetime string
      targetDate = new Date(dateString);
    } else if (dateString.includes(' ')) {
      // Date with time (e.g., "2025-05-31 14:30")
      const [datePart, timePart] = dateString.split(' ');
      const [year, month, day] = datePart.split('-').map(num => parseInt(num, 10));
      const [hours, minutes] = timePart.split(':').map(num => parseInt(num, 10));
      targetDate = new Date(`${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}T${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00+01:00`);
    } else {
      // Just date, assume end of day
      const [year, month, day] = dateString.split('-').map(num => parseInt(num, 10));
      targetDate = new Date(`${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}T23:59:59+01:00`);
    }
    
    // Create countdown display element if it doesn't exist
    /*let countdownElement = releaseButton.querySelector('.countdown-display');
    if (!countdownElement) {
      countdownElement = document.createElement('div');
      countdownElement.className = 'countdown-display';
      countdownElement.style.cssText = `
        font-size: 12px;
        margin-top: 5px;
        font-weight: bold;
        color: #ff6600;
        text-align: center;
        line-height: 1.2;
      `;
      releaseButton.appendChild(countdownElement);
    }*/
    
    // Function to update this button's countdown
    function updateButtonCountdown() {
      const now = new Date();
      const timeDifference = targetDate - now;
      
      // If countdown finished
      if (timeDifference <= 0) {
        // Hide the release button
        releaseButton.classList.add('hide');
        
        // Show the corresponding ATC button
        if (atcButton) {
          atcButton.classList.remove("hide");
        }
        
        // Clear this button's interval
        const interval = activeIntervals.get(buttonId);
        if (interval) {
          clearInterval(interval);
          activeIntervals.delete(buttonId);
        }
        return;
      }
      
      // Calculate time components
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      
      // Format with leading zeros
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');
      
      // Update the countdown display
      let displayText;
      if (days > 0) {
        displayText = `${days}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      } else {
        displayText = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      }
      //console.log(displayText, releaseButton);
      //countdownElement.innerHTML = displayText;
    }
    
    // Run immediately once
    updateButtonCountdown();
    
    // Set interval to update every second
    const interval = setInterval(updateButtonCountdown, 1000);
    activeIntervals.set(buttonId, interval);
  }
  
  // Initialize countdown for each release button
  releaseButtons.forEach(button => {
    createCountdownForButton(button);
  });
  
  // Function to manually pair release and ATC buttons if needed
  window.pairButtons = function(releaseButtonSelector, atcButtonSelector) {
    const releaseBtn = document.querySelector(releaseButtonSelector);
    const atcBtn = document.querySelector(atcButtonSelector);
    
    if (releaseBtn && atcBtn) {
      releaseBtn.setAttribute('data-atc-pair', atcBtn.id || 'paired-atc');
      if (!atcBtn.id) {
        atcBtn.id = 'paired-atc-' + Math.random().toString(36).substr(2, 9);
      }
    }
  };
  
  // Cleanup function
  window.cleanupCountdowns = function() {
    activeIntervals.forEach(interval => clearInterval(interval));
    activeIntervals.clear();
  };
};

// Initialize the widget
collectionDropInWidget();
document.addEventListener("DOMContentLoaded", function() {
  waitForSwiper(() => {
if(document.querySelectorAll(".custom-blog-slider-slider").length > 0){
  const customblogBlogSliders = new Swiper('.custom-blog-slider-slider', {
        // Optional parameters
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 2.5,
        roundLengths: true,
        loop: false,
        breakpoints: {
            1199: {
                slidesPerView: 2.5,
            },
            991: {
                slidesPerView: 2.5,
            },
            800: {
                slidesPerView: 2.5,
            },
            500: {
                slidesPerView: 1.2,
            },
          320: {
                slidesPerView: 1.1,
            },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });
  }
  
if(document.querySelectorAll(".custom-blog-posts-slider").length > 0){
  const customblogPostSliders = new Swiper('.custom-blog-posts-slider', {
        // Optional parameters
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 2.5,
        roundLengths: true,
        loop: false,
        pagination: {
          el: '.slider__pagination',
          clickable: true,
        },
        breakpoints: {
            1199: {
                slidesPerView: 2.5,
            },
            991: {
                slidesPerView: 2.5,
            },
            800: {
                slidesPerView: 2.5,
            },
            500: {
                slidesPerView: 1.5,
            },
          320: {
                slidesPerView: 1.3,
            },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });
  }
  if(document.querySelectorAll(".custom-tag-filter-css-slider").length > 0){
  const customTagSliders = new Swiper('.custom-tag-filter-css-slider', {
        // Optional parameters
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 2.3,
        roundLengths: true,
        loop: false,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
         breakpoints: {
          500: {
                slidesPerView: 'auto',
            },
         }
    });
  }
  });
});

function removeEmojis(text) {
  return text.replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, '');
}